<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">USUARIOS DE APP</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">

                <table mat-table [dataSource]="allUsers" class="mat-elevation-z0">

                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef class="table-header">USUARIO</th>
                        <td mat-cell *matCellDef="let user"> {{user.dsName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="table-header">CORREO ELECTRÓNICO</th>
                        <td mat-cell *matCellDef="let user"> {{user.dsEmail}} </td>
                    </ng-container>

                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TELÉFONO</th>
                        <td mat-cell *matCellDef="let user">
                            {{user.dsPhone}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="registerDate">
                        <th mat-header-cell *matHeaderCellDef class="table-header">FECHA DE REGISTRO</th>
                        <td mat-cell *matCellDef="let user"> {{user.dtCreatedAt | date }} </td>
                    </ng-container>

                    <ng-container matColumnDef="totalOrders">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL DE ÓRDENES</th>
                        <td mat-cell *matCellDef="let user"> {{user.cantidadOrdenes}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>